export const getEditSuccess = (name: string): string =>
  `Права пользователя "${name}" на ЭЗС обновлены`;
export const getEditError = (name: string): string =>
  `Не удалось обновить права пользователя "${name}" на ЭЗС`;

export const getEditUserRoleSuccess = (name: string): string =>
  `Роли пользователя "${name}" обновлены`;
export const getEditUserRoleError = (name: string): string =>
  `Не удалось обновить роли пользователя "${name}"`;
